import { Layer, Source } from "react-map-gl/maplibre";
import { toLineCoordinates } from "../utils/coordinates";

interface FlightPathLayerProps {
  flightId: string;
  path: [number, number][];
}

const FlightPathLayer: React.FC<FlightPathLayerProps> = ({
  flightId,
  path,
}) => {
  if (path.length < 2) {
    return null;
  }

  const safeId = flightId.replace(/[^a-zA-Z0-9-_]/g, "-");
  const sourceId = `flight-path-source-${safeId}`;
  const data = {
    type: "Feature" as const,
    properties: {},
    geometry: {
      type: "LineString" as const,
      coordinates: toLineCoordinates(path),
    },
  };

  return (
    <Source id={sourceId} type="geojson" data={data}>
      <Layer
        id={`flight-path-layer-${safeId}`}
        type="line"
        layout={{ "line-cap": "round", "line-join": "round" }}
        paint={{
          "line-color": "#9d4edd",
          "line-width": 4,
          "line-opacity": 0.9,
        }}
      />
    </Source>
  );
};

export default FlightPathLayer;
